module.exports = __webpack_public_path__ + "img/qr.0d596883.jpg";